import { Card, Col, Row } from 'reactstrap';
import { toLocaleFormatSlash } from '../../../helpers/dateFormat';

interface PutOnLeaveSummaryProps {
  loaUser: any;
  firstDayOfLoa: string | Date;
  lastDayOfLoa: string | Date;
  typeOfLoa: string;
  selectedLoaPolicy: any;
  selectedLoaReason: string;
  reasonForLoa: string;
  documents: File[];
  additionalNotes: string;
}

const PutOnLeaveSummary = ({
  loaUser,
  firstDayOfLoa,
  lastDayOfLoa,
  selectedLoaPolicy,
  selectedLoaReason,
  reasonForLoa,
  documents,
  additionalNotes,
}: PutOnLeaveSummaryProps) => {
  return (
    <Card style={{ padding: '40px 60px', background: '#eaeaff' }}>
      <Row className="mb-2">
        <h3>Summary</h3>
      </Row>

      <Row
        className="d-flex mb-2 align-items-center justify-content-between"
        style={{ borderBottom: '2px solid #dddddd' }}
      >
        <h4 className="text-muted">Worker</h4>
        <h4>{`${loaUser?.user?.firstName || ''} ${loaUser?.user?.lastName || ''}`}</h4>
      </Row>

      <Row
        className="d-flex mb-2 align-items-center justify-content-between"
        style={{ borderBottom: '2px solid #dddddd' }}
      >
        <h4 className="text-muted">Estimated Start and End Dates</h4>
        <h4>
          {firstDayOfLoa && lastDayOfLoa
            ? `${toLocaleFormatSlash(firstDayOfLoa)} - ${toLocaleFormatSlash(lastDayOfLoa)}`
            : '--'}
        </h4>
      </Row>

      <Row
        className="d-flex mb-2 align-items-center justify-content-between"
        style={{ borderBottom: '2px solid #dddddd' }}
      >
        <h4 className="text-muted">Actual Start and End Dates</h4>
        <h4>--</h4>
      </Row>

      <Row
        className="d-flex mb-2 align-items-center justify-content-between"
        style={{ borderBottom: '2px solid #dddddd' }}
      >
        <h4 className="text-muted">Leave Of Absence Policy</h4>
        <h4>{selectedLoaPolicy?.name || '--'}</h4>
      </Row>

      {selectedLoaReason && (
        <Row
          className="d-flex mb-2 align-items-center justify-content-between"
          style={{ borderBottom: '2px solid #dddddd' }}
        >
          <h4 className="text-muted">Selected Reason</h4>
          <h4>{selectedLoaReason}</h4>
        </Row>
      )}

      <Row className="d-flex mb-2 justify-content-between" style={{ borderBottom: '2px solid #dddddd' }}>
        <Col className="p-0 m-0" lg="4">
          <h4 className="text-muted">Leave Reason</h4>
        </Col>
        <Col className="p-0 m-0" lg="8">
          <h4 className="text-right" style={{ whiteSpace: 'pre-line' }}>
            {reasonForLoa || '--'}
          </h4>
        </Col>
      </Row>

      <Row className="d-flex mb-2 justify-content-between" style={{ borderBottom: '2px solid #dddddd' }}>
        <Col className="p-0 m-0" lg="4">
          <h4 className="text-muted">Documentation</h4>
        </Col>
        <Col className="p-0 m-0" lg="8">
          <h4 className="text-right">
            {documents.length > 0
              ? documents.map((doc, index) => (
                  <div key={index} style={{ fontSize: '0.9rem', marginBottom: '4px' }}>
                    {doc.name}
                  </div>
                ))
              : '--'}
          </h4>
        </Col>
      </Row>

      <Row className="d-flex mb-2 justify-content-between" style={{ borderBottom: '2px solid #dddddd' }}>
        <Col className="p-0 m-0" lg="4">
          <h4 className="text-muted">Additional Notes</h4>
        </Col>
        <Col className="p-0 m-0" lg="8">
          <h4 className="text-right" style={{ whiteSpace: 'pre-line' }}>
            {additionalNotes || '--'}
          </h4>
        </Col>
      </Row>
    </Card>
  );
};

export default PutOnLeaveSummary;
